import { render, staticRenderFns } from "./AddRoomComponent.vue?vue&type=template&id=317bcf70&scoped=true&"
import script from "./AddRoomComponent.vue?vue&type=script&lang=js&"
export * from "./AddRoomComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddRoomComponent.vue?vue&type=style&index=0&id=317bcf70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317bcf70",
  null
  
)

export default component.exports